import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTopRivals } from "../lib/api";
import { AvatarChip } from "./AvatarChip";

/**
 * RivalsCard — dashboard widget. Shows the 5 players you've matched
 * against the most this season with a W-L line per opponent. Renders
 * nothing on fresh accounts (no matches → no rivals).
 */
export function RivalsCard({ userId }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!userId) return;
    fetchTopRivals(userId, 5).then((r) => setRows(r.rows || [])).catch(() => setRows([]));
  }, [userId]);
  if (rows === null) return null;
  if (rows.length === 0) return null;
  return (
    <div className="glass rounded-3xl p-4" data-testid="rivals-card">
      <p className="text-[10px] tracking-[3px] text-[#14b8a6] font-bold mb-3">
        <i className="fas fa-swords mr-1" />TOP RIVALS
      </p>
      <ul className="space-y-2">
        {rows.map((r) => (
          <li key={r.user_id}
              data-testid={`rival-row-${r.user_id}`}
              className="flex items-center gap-2 text-sm">
            <AvatarChip avatarId={r.avatar_id} pfpUrl={r.pfp_url} size={26} />
            <Link to={`/players/${r.user_id}`}
                  className="flex-1 truncate text-white/85 hover:text-white">
              {r.name}
            </Link>
            <span className="font-mono text-[11px]">
              <span className="text-[#14b8a6]">{r.wins}</span>
              <span className="text-white/40">-</span>
              <span className="text-[#14b8a6]">{r.losses}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
